import "../../shared/theme/global.css";
import React, { useRef } from "react";
import { BsMoonFill, BsSunFill } from "react-icons/bs";
import Logo from "../layout/logo";
import SearchBox, { SearchBoxHandle } from "../search/searchbox";
import BoxMenuDrop from "../layout/boxmenudrop";
import ProfileMenuDrop from "../layout/profilemenudrop";
import ChatToggleButton from "../chat/ChatToggleButton";
import Footer from "../layout/footer";
import { useTheme } from "../../shared/theme/ThemeContext";

function Home() {
  const searchRef = useRef<SearchBoxHandle>(null);
  const { darkMode, toggleDarkMode } = useTheme();

  return (
    <div className="home main">
      <div className="top-menu">
        <ChatToggleButton />
        <button
          onClick={toggleDarkMode}
          className="theme-toggle"
          aria-label="Toggle dark mode"
          aria-pressed={darkMode}
        >
          {darkMode ? <BsSunFill /> : <BsMoonFill />}
        </button>
        <BoxMenuDrop />
        <ProfileMenuDrop />
      </div>

      <div className="flex-center">
        <div className="search-container">
          <div className="frontpage-logo">
            <Logo />
          </div>

          <SearchBox ref={searchRef} />

          <div className="search-btns">
            <input
              className="search-btn sw"
              type="button"
              value="Search Website"
              onClick={() => searchRef.current?.search()}
            />
            <input
              className="search-btn ifl"
              type="button"
              value="I'm Feeling Lucky"
              onClick={() => searchRef.current?.feelingLucky()}
            />
          </div>

        </div>
      </div>

      <Footer />
    </div>
  );
}

export default Home;
